import PropTypes from 'prop-types';
function TeacherStatsLiveProjects({ isTeacher, liveProposals, numProjectsCurrentlyLive }) {
    function listTitle() {
        if (!isTeacher) {
            return liveProposals.length ? 'Recently Posted Projects:' : '';
        }
        return liveProposals.length ? 'Recently Posted Projects:' : 'request items for your classroom';
    }

    function createProjectLink() {
        if (!isTeacher) {
            return null;
        }
        return liveProposals.length ? '' : (<a href='/teacher/projectcreation-welcome.html'><div className='projectRow button-primary small'>Create a new project now</div></a>);
    }

    return (
        <section className="teacherLiveProjects">

            <section className="teacherLiveProjectsWrapper">

                <section className='liveCount'>
                    <div aria-label='book graphic' className='illustration book'></div>
                    <h2>{numProjectsCurrentlyLive}</h2>
                    <h3>Live projects</h3>
                </section>

                <section className='liveList'>
                    <h4>{listTitle()}</h4>
                    {createProjectLink()}
                    {/* For the first three projects, create a project link */}
                    {
                        liveProposals.slice(0, 3).map(project => {
                            {/* WS-34556: Temporarily unlink CE projects */}
                            if (project.essentialsListShipment) {
                                return (
                                    <div key={project.name}>
                                        <div className="projectRow">{project.name}</div>
                                    </div>
                                );
                            }
                            return <a key={project.name} href={'/' + project.url}>
                                <div className="projectRow">{project.name}</div>
                            </a>;
                        })
                    }
                </section>

            </section>

        </section>
    );
}

TeacherStatsLiveProjects.propTypes = {
    isTeacher: PropTypes.bool.isRequired,
    liveProposals: PropTypes.array.isRequired,
    numProjectsCurrentlyLive: PropTypes.number.isRequired,
};

export default TeacherStatsLiveProjects;
